module.exports = __webpack_public_path__ + "aeffda4198999ccef617dc888d079831.jpg";